export default function Testimonials() {
  const testimonials = [
    {
      name: 'María González',
      role: 'Adiestradora Profesional',
      image: 'https://public.readdy.ai/ai/img_res/48a29d8ebc01986baa682a4dd0a050d4.jpg',
      content: 'La formación en Aula K9 Arete Can ha sido excepcional. El contenido es muy completo y práctico, y ahora trabajo como adiestradora profesional con mi propia empresa. La certificación oficial me ha abierto muchas puertas en el sector.',
      rating: 5
    },
    {
      name: 'Carlos Martínez',
      role: 'Educador Canino',
      image: 'https://readdy.ai/api/search-image?query=Professional%20spanish%20man%20dog%20trainer%20smiling%20portrait%20outdoors%20with%20dogs%2C%20friendly%20professional%20appearance%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-002&orientation=squarish',
      content: 'Excelente metodología paso a paso. Los vídeos y el material didáctico son de altísima calidad. Los tutores siempre disponibles para resolver dudas. Totalmente recomendable para quien quiera dedicarse profesionalmente al adiestramiento canino.',
      rating: 5
    },
    {
      name: 'Laura Fernández',
      role: 'Técnica en Modificación de Conductas',
      image: 'https://readdy.ai/api/search-image?query=Professional%20spanish%20woman%20dog%20behaviorist%20smiling%20portrait%20in%20modern%20office%2C%20professional%20appearance%20with%20glasses%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-003&orientation=squarish',
      content: 'Me ha encantado la parte de modificación de conductas. Ahora puedo ayudar a familias con perros que tienen problemas de comportamiento. La formación es muy práctica y aplicable al día a día. El certificado oficial es un gran valor añadido.',
      rating: 5
    },
    {
      name: 'Javier Ruiz',
      role: 'Adiestrador Deportivo',
      image: 'https://readdy.ai/api/search-image?query=Professional%20spanish%20man%20sports%20dog%20trainer%20smiling%20portrait%20in%20training%20field%2C%20athletic%20professional%20appearance%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-004&orientation=squarish',
      content: 'La mejor inversión que he hecho en mi carrera profesional. El programa formativo es muy completo y actualizado. Ahora entreno perros para competiciones deportivas y la base que obtuve aquí ha sido fundamental para mi éxito.',
      rating: 5
    },
    {
      name: 'Ana Sánchez',
      role: 'Propietaria de Centro Canino',
      image: 'https://readdy.ai/api/search-image?query=Professional%20spanish%20woman%20business%20owner%20smiling%20portrait%20in%20dog%20training%20center%2C%20confident%20entrepreneur%20appearance%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-005&orientation=squarish',
      content: 'Gracias a esta formación pude abrir mi propio centro de adiestramiento. El conocimiento adquirido sobre bienestar animal y riesgos laborales me ha permitido crear un negocio profesional y seguro. Muy agradecida con todo el equipo.',
      rating: 5
    },
    {
      name: 'David López',
      role: 'Especialista en Primeros Auxilios',
      image: 'https://readdy.ai/api/search-image?query=Professional%20spanish%20man%20veterinary%20assistant%20smiling%20portrait%20in%20clinic%2C%20caring%20professional%20appearance%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-006&orientation=squarish',
      content: 'El módulo de primeros auxilios es imprescindible para cualquier profesional del sector. He podido salvar la vida de varios perros gracias a lo aprendido. La formación online me permitió estudiar a mi ritmo sin dejar mi trabajo actual.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Alumnos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Más de 500 profesionales formados que ahora trabajan en el sector del adiestramiento canino. Sus historias de éxito nos motivan cada día a seguir mejorando nuestra formación.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top"
                />
                <div>
                  <h3 className="font-bold text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-4xl font-bold text-secondary-600 mb-2">500+</p>
              <p className="text-gray-600">Alumnos Formados</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-secondary-600 mb-2">98%</p>
              <p className="text-gray-600">Tasa de Éxito</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-secondary-600 mb-2">4.9/5</p>
              <p className="text-gray-600">Valoración Media</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-secondary-600 mb-2">360h</p>
              <p className="text-gray-600">Formación Completa</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
